<template>
  <SogCard class="sog-card-without-title">
    <SogCardContent>
      <table>
        <tr>
          <td>Datum</td>
          <td>
            <SogDataLabel
              :value="props.orderHead?.orderedDate"
              value-type="DateTime"
            />
          </td>
        </tr>
        <tr>
          <td>Kunde</td>
          <td><SogDataLabel :value="props.orderHead?.personName" /></td>
        </tr>
        <tr>
          <td>Lieferant</td>
          <td><SogDataLabel :value="props.orderHead?.supplierName" /></td>
        </tr>
        <tr>
          <td>Bestellt durch</td>
          <td><SogDataLabel :value="props.orderHead.personName" /></td>
        </tr>
        <tr v-show="props.orderHead.orderType===OrderType.Invoice">
          <td>Bezahlt</td>
          <td>
            <span
              v-show="props.orderHead.paid"
              class="e-badge e-badge-success e-badge-pill"
            >ja</span><span
              v-show="!props.orderHead.paid"
              class="e-badge e-badge-danger e-badge-pill"
            >nein</span>
          </td>
        </tr>
        <tr v-show="props.orderHead.orderType===OrderType.Order">
          <td>Abgerechnet</td>
          <td>
            <span
              v-show="props.orderHead.invoiced"
              class="e-badge e-badge-success e-badge-pill"
            >ja</span><span
              v-show="!props.orderHead.invoiced"
              class="e-badge e-badge-danger e-badge-pill"
            >nein</span>
          </td>
        </tr>
        <tr v-show="props.orderHead.statusId!==OrderStatus.Completed">
          <td>Status</td>
          <td>
            <SogIcon
              icon="mdi-truck-fast"
            />
          </td>
        </tr>
      </table>
    </SogCardContent>
  </SogCard>
</template>

<script setup lang="ts">

import OrderHead, {OrderStatus, OrderType} from "@/shared/model/orderHead";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogIcon from "@/shared/ui/SogIcon.vue";

interface Props {
  orderHead:OrderHead
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  orderHead:undefined
  }
)




</script>

<style scoped>
</style>
